export enum TeaserStyleType {
  FULL_IMG_TEASER = 'Full Image Teaser',
  BOXED_IMG_TEASER = 'Boxed Image Teaser',
  LIST_TEASER = 'List Teaser',
}
